import { jsx } from 'panel';
import { SvgIconEl } from 'common/components/svg-icon';
export function template() {
  const disabled = this.attr("disabled");
  const on = this.attr("on");
  return jsx("div", {
    sel: '.mp-switch',
    class: {
      'switch-on': on,
      'switch-off': !on,
      disabled
    },
    on: {
      click: disabled ? null : this.helpers.toggleSwitch
    }
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "checkmark"
    }
  }));
}